import API from '../../../helpers/request/api';

const api = () => new API();

const update = (updatedProfile) => {
  const { id, name } = updatedProfile;
  const newPassword = updatedProfile.newPassword || '';
  const photo = updatedProfile.photo || '';

  const query = {
    query: `mutation updateUserProfile {
      updateUserProfile(input: {
        id: ${id}
        name: "${name}"
        new_password: "${newPassword}"
        photo: "${photo}"
      })
      {
        user {
          id
          name
          email
          photo
          language {
            id
            slug
            name
          }
        }
      }
    }`,
  };

  return api().get(query);
};

export default {
  update,
};



// WEBPACK FOOTER //
// ./src/screens/Profile/queries/profile.js